module.exports = {
    header: {
        home: '科技资源标识服务平台',
        home1: '首页',
        home2: '科学数据',
        home3: '科研人员',
        home6: '成为会员',
        home7: '关于我们',
        home8: '工作成果',
        home9: '工作经历',
        home10: '国际合作',
        home11: '新闻详情',
        home15: "最新动态",
        "home16": "国际合作",
        "home17": "文献引用量查询",
        "home18": "请输入您想要查询的机构代码，例如：31253",
        "home19": "国际标准",
        "home20": "CSTR成为国际协议标识符",
        "home21": "科研人员",
        "home22": "科研机构",
        "home23": "合作伙伴",
        "home24": "种质资源",
        "home25": "仪器设备",
        "home26": "国际组织采纳",
        "home27": "预印本",
        "home28": "专利",
        "home29": "资源引用情况",
        "home30": "详情",
        "home31": "生物物种",
        "home32": "前缀查询",
        "home33": "学位论文",
        "dynamic": "新增数据",
        "researchers": "科研人员",
        "title": "全球科技资源标识",
        "subtitle": "开放共享基础设施",
        "facility": "重大基础设施"

    },

    main: {
        home1: '标题、CSTR',
        homes: '姓名、ORCID',
        content1: '机构名称',
        content2: '项目名称',
        content3: '机构',
        content4: '人员',
        content5: '注册量',
        content6: '解析量',
        content7: '提供标识服务',
        content8: '标识注册',
        content9: '标识解析',
        content10: '标识检索',
        content11: '沙盒环境',
        content12: '分配唯一标识，国家科技资源CSTR与国际科技资源HANDLE双标识。',
        content13: '永久获取科技资源，CSTR、SDI、HANDLE等原始科技资源定位链接。',
        content14: '优质资源推送，推送至国际ORCID等资源库。',
        content15: '提供标识注册测试环境，辅助快速使用。',
        content16: '学术成果分享',
        content17: '通过标识快速分享学术成果，获得学术成果传播途径监测统计数据。',
        content18: '分支机构管理',
        content19: '支持再分配功能，为其下分支机构分配代码，支撑分支机构资源审核汇聚等。',
        content20: '科技资源唯一认证',
        content21: '为科技资源分配具有国家标准“身份证”，纳入国家科技资源体系。',
        content22: '发布机构',
        content24: '为您找到',
        content25: '条数据',
        content26: '应用场景',
        content27: '暂无数据',
        "content28": '论文名称，关键词，作者',
        "content29": "英文名称：",
        "content30": "专利"
    },
    search: {
        search1: '发表时间',
        search2: '发布机构',
        search3: '描述',
        search4: '搜索',
        "search6": "展开",
        "search7": "收起",
        "search8": "关键词："
    },
    "guide": {
        "guide0": "CSTR引用格式指南是为使用者提供展示CSTR的统一引用格式，以提升CSTR与论文关联的数据质量。",
        "guide1": "CSTR引用格式指南",
        "guide2": "CSTR引用格式建议采用以下方式：",
        "guide3": "考虑以下场景中使用CSTR的展示方式",
        "guide4": "1、参考文献中的CSTR，建议展示方式如下：",
        "guide5": "2、资源页面中的CSTR，建议展示方式如下：",
        "guide6": "CSTR直接在页面上展示，例如：",
        "guide7": "，并添加解析链接",
        "guide8": "通过将下方代码粘贴至对应资源的网页",
        "guide9": "复制",
        "guide10": "可以实现点击CSTR标识，通过解析链接跳转到编码所对应网页。",
        "guide11": "也可以通过扫描CSTR二维码访问到编码所对应网页。",
        "guide12": "平台提供二维码生成服务，通过将下方代码嵌入资源网页可以实现标识二维码生成。",
        "guide13": "注：",
        "guide14": "使用代码时请注意将代码网址后标识更换为资源页面对应标识。",
        "guide15": "平台提供两种样式二维码。当提交参数中style=1时生成二维码使用样式1，style=0时生成二维码使用样式2。",
        "guide16": "样式1",
        "guide17": "样式2",
        "guide18": "3、集成解析服务",
        "guide19": "平台提供集成解析服务，通过将下方代码粘贴至对应资源的网页，可以实现在本地进行标识解析。",
        "guide20": "引用指南"

    },
    newData: {
        "newData1": "学术成果",
        "newData2": "关联关系",
        "newData3": "统计信息",
        "newData4": "成果数",
        "newData5": "成果引用量",
        "newData6": "成果解析量",
        "newData7": "个人访问量",
        "newData8": "职位名称",
        "newData9": "会员信息",
        "newData10": "会员名称：",
        "newData11": "奖项信息",
        "newData12": "奖项名称：",
        "newData13": "合作学者",
        "newData14": "单篇最多",
        "newData15": "单人合作",
        "newData16": "合作期刊",
        "newData17": "参与会议",
        "newData18": "合作期刊列表",
        "newData19": "相关成果列表",
        "newData20": "摘要：",
        "newData21": "来源：",
        "newData22": "作 者：",
        "newData23": "暂无数据集数据",
        "newData24": "总赞助项目",
        "newData25": "重点研发",
        "newData26": "中科院",
        "newData27": "自然基金",
        "newData28": "关联成果",
        "newData29": "赞助列表",
        "newData30": "关联成果信息",
        "newData31": "发布时间：",
        "newData32": "暂无专利数据",
        "newData33": "暂无期刊论文数据",
        "newData34": "统计概览",
        "newData35": "总成果数",
        "newData36": "期刊论文",
        "newData37": "引用信息",
        "newData38": "高质量引用",
        "newData39": "论文名称：",
        "newData40": "成果列表",
        "newData41": "近七天个人访问量趋势图",
        "newData42": "合作学者TOP10",
        "newData43": "期刊合作排名",
        "newData44": "序号",
        "newData45": "赞助名称",
        "newData46": "赞助编号",
        "newData47": "赞助类型",
        "newData48": "发布日期",
        "newData49": "关联成果量",
        "newData50": "年度赞助变化趋势",
        "newData51": "期刊名称：",
        "newData52": "引用标识",
        "newData53": "标识DOI",
        "newData54": "引用期刊",
        "newData55": "期刊影响因子",
        "newData56": "论文名称"
    },
    detail: {
        detail1: '基本信息',
        detail2: '发布机构',
        detail3: '标识',
        detail4: '发布日期',
        detail5: '共享途径',
        detail6: '共享范围',
        detail7: '资源链接',
        detail8: '提交机构信息',
        detail9: '机构名称',
        detail10: '机构地址',
        detail11: '机构邮编',
        detail12: '机构邮箱',
        detail13: '注册机构信息',
        detail14: '机构名称',
        detail15: '开始时间',
        "detail16": "创建者信息",
        "detail17": "所属机构",
        "detail18": "所属机构标识符：",
        "detail19": "机构名称：",
        "detail20": "标识："
    },
    people: {
        people1: '成果',
        people2: '引用',
        people3: '个人简介',
        people4: '工作经历',
        people5: '机构ID类型',
        people6: '所在国家',
        people7: '机构ID',
        people8: '部门名称',
        people9: '资格证书',
        people10: '所在城市',
        people11: '证书名称',
        people12: '工作成果',
        people13: '发布机构',
        people14: '标识类型',
        people15: '资源标识',
        people161: '教育经历',
        people16: '更多',
        people17: '工作成果',
        people18: '工作时间',
        people19: '职位',
        people20: '赞助列表',
        people21: '编号',
        people22: '资助类型',
        people23: '发布日期',
        people24: '关联成果量',
        people25: '关联关系',
        people26: '关键词',
        people27: '起止时间',
        people28: '成果',
        people29: '引用'
    },
    organ: {
        organ1: '发表日期',
        organ2: '所属机构',
        organ3: '类别',
        organ4: '内容类型',
        organ5: '学科',
        organ6: '描述',
        organ7: '链接',
        organ8: '学科分类',
        organ9: '关键词',
        organ10: '工作成果',
    },
    eu: {
        eu1: '欧洲委员会',
        eu2: '美国自然科学基金会',
        eu3: '起止日期',
        eu4: '项目简称',
        eu5: '项目状态',
        eu6: '国家',
        eu7: '目标',
        eu8: '简称',
        eu9: '资金计划',
        eu10: '项目总成本',
        eu11: '所属董事会',
        eu12: '联系人',
        eu13: '项目机构',
        eu14: '奖励总金额',
        eu15: '奖项类别',
        eu16: '名称',
        eu17: '缩写',
        eu18: '对应部门',
        eu19: '部门缩写',
        eu20: '人员信息',
        eu21: '人员',
        eu22: '联系邮箱',
        eu23: '联系电话',
        eu24: '关联人员',
        eu25: '查看',
        eu26: '执行机构',
        eu27: '机构名称',
        eu28: '所在国家',
        eu29: '机构编码',
        eu30: '所在地址',
        eu31: '受奖机构',
        eu32: '机构地址',
        eu33: '参与国家'

    },
    "ror": {
        "ror1": "机构名称 ",
        "ror2": "类 型: ",
        "ror3": "状 态: ",
        "ror4": "国 家: ",
        "ror5": "建立日期：",
        "ror6": "机构状态：",
        "ror7": "机构官网：",
        "ror8": "机构类型：",
        "ror9": "机构名称：",
        "ror10": "机构类型",
        "ror11": "建立日期",
        "ror12": "所在国家",
        "ror13": "机构官网：",
    },
    "rorDetail": {
        "rorDetail1": "其他标识",
        "rorDetail2": "所在国家：",
        "rorDetail3": "相关机构",
        "rorDetail4": "关联名称：",
        "rorDetail5": "关联类型：",
        "rorDetail6": "机构名称："
    },
    nsf: {
        "nsf1": "项目与组织机构：",
        "nsf2": "奖励类型:",
        "nsf3": "董事会:",
        "nsf4": "关联国家: ",
        "nsf5": "受奖者:",
        "nsf6": "日期:",
        "nsf7": "关联国家:",
        "nsf8": "奖励类型：",
        "nsf9": "所属董事会：",
        "nsf10": "概述："
    },
    nsfdetail: {
        "nsfdetail1": "基础信息",
        "nsfdetail2": "项目名称：",
        "nsfdetail3": "起止日期：",
        "nsfdetail4": "项目机构: ",
        "nsfdetail5": "奖励总金额: ",
        "nsfdetail6": "奖项类别:",
        "nsfdetail7": "最晚修改日期: ",
        "nsfdetail8": "最新修改日期:",
        "nsfdetail9": "项目概述：",
        "nsfdetail10": "所属董事会",
        "nsfdetail11": "董事会名称：",
        "nsfdetail12": "董事会缩写：",
        "nsfdetail13": "对应部门：",
        "nsfdetail14": "部门缩写：",
        "nsfdetail15": "人员信息",
        "nsfdetail16": "负责人名称：",
        "nsfdetail17": "联系邮箱",
        "nsfdetail18": "联系电话",
        "nsfdetail19": "职称",
        "nsfdetail20": "其他名称",
        "nsfdetail21": "联系电话",
        "nsfdetail22": "执行机构",
        "nsfdetail23": "机构名称",
        "nsfdetail24": "所在国家",
        "nsfdetail25": "所在城市",
        "nsfdetail26": "机构编码",
        "nsfdetail27": "机构地址",
        "nsfdetail28": "受奖机构",
        "nsfdetail29": "机构名称 ",
        "nsfdetail30": "所在国家 ",
        "nsfdetail31": "所在城市 ",
        "nsfdetail32": "机构编码 ",
        "nsfdetail33": "机构地址 ",
        "nsfdetail34": "组织DUNS编号 ",
        "nsfdetail35": "组织伙伴DUNS编号 ",
        "nsfdetail36": "奖励金额 "
    },
    peopleDetail: {
        "peopleDetail1": "基础信息",
        "peopleDetail2": "ORCID原始解析页面",
        "peopleDetail3": "姓名 ",
        "peopleDetail4": "其他姓名：",
        "peopleDetail5": "国家：",
        "peopleDetail6": "个人URL ",
        "peopleDetail7": "基本信息",
        "peopleDetail8": "暂无基本信息",
        "peopleDetail9": "关联作者",
        "peopleDetail10": "成果：",
        "peopleDetail11": "引用：",
        "peopleDetail12": "暂无关联作者",
        "peopleDetail13": "个人简介",
        "peopleDetail14": "简介：",
        "peopleDetail15": "工作经历",
        "peopleDetail16": "机构ID类型 ",
        "peopleDetail17": "所在国家 ",
        "peopleDetail18": "机构ID ",
        "peopleDetail19": "部门名称：",
        "peopleDetail20": "资助计划(行动类型)：",
        "peopleDetail21": "受邀职位",
        "peopleDetail22": "资格证书",
        "peopleDetail23": "培训机构名称：",
        "peopleDetail24": "所在城市 ",
        "peopleDetail25": "证书名称 ",
        "peopleDetail26": "教育经历",
        "peopleDetail27": "赞助信息",
        "peopleDetail28": "项目名称",
        "peopleDetail29": "所属机构 ",
        "peopleDetail30": "项目编号 ",
        "peopleDetail31": "赞助类型 ",
        "peopleDetail33": "工作成果",
        "peopleDetail34": "发布机构 ",
        "peopleDetail35": "资源标识类型：",
        "peopleDetail36": "资源标识 ",
        "peopleDetail37": "暂无开放数据",
        "peopleDetail38": "研究兴趣",
        "peopleDetail39": "更多",
        "peopleDetail40": "来源",
        "peopleDetail41": "发布时间",
    },
    "online": {
        "online1": "在线申请",
        "online2": "机构名称",
        "online3": "联系人",
        "online4": "邮箱",
        "online5": "确定",
        "online6": "取消",
        "online7": "机构名称不能为空",
        "online8": "联系人不能为空",
        "online9": "邮箱不能为空",
        "online10": "请输入正确邮箱"
    },
    "grid": {
        "grid1": "其他名称",
        "grid2": "机构缩写"

    },
    "apply": {
        "apply1": "申请已提交",
        "apply2": "输入邮箱已申请",
        "apply3": "系统繁忙，请稍后再试"
    },
    "resolve": {
        "resolve1": "科技资源标识服务平台",
        "resolve2": "科技资源标识服务平台旨在通过唯一标识推动构建跨学科、跨地域、跨平台的全球科技资源互联互通体系，追踪科技资源全球影响，实现科技资源全球范围快速定位与获取，是开放科学与科研创新环境建设的数字化底座。",
        "resolve3": "1、注册服务",
        "resolve4": "通过科技资源标识和元数据的注册，使所发布的科技资源更易被发现和使用。",
        "resolve5": "2、查询服务",
        "resolve6": "通过科技资源标识、关键字、元数据等作为输入条件，提供便捷的查询搜索服务。",
        "resolve7": "3、关联服务",
        "resolve8": "通过科技资源标识将论文与作者、论文与资源关联起来，在庞大的关联网络中，将研究过程和成果数据联系在一起。",
        "resolve9": "4、数据服务",
        "resolve10": "提供资源总量、解析量、查询量等多维度统计分析的数据服务。",
        "resolve12": "我们的服务：",
        "resolve11": "基于我国",
        "resolve14": "国家标准GB/T 32843—2016《科技资源标识》",
        "resolve13": "建设，面向全球科学数据、论文、预印本、专利等科技资源提供唯一标识服务，是我国国家标准服务全球科技资源的重要载体，是推动我国标准国际互认的全球通用基础服务平台。"
    },
    "member": {
        "member1": "成为会员主要需要以下三步：",
        "member2": "1、前缀申请 ",
        "member3": "请发邮件至cstr@cnic.cn咨询",
        "member31": "",
        "member32": "。",
        "member4": "2、成为会员",
        "member5": "平台收到邮件申请后将在3-5个工作日邮件通知结果，并将CSTR前缀等信息发送至申请邮箱。",
        "member6": "3、标识注册",
        "member7": "审核通过后，平台将为用户提供平台操作手册，方便用户快速上手标识注册等相关流程。如遇任何问题，请将问题发送至",
        "member8": "前缀申请",
        "member9": "成为会员",
        "member10": "标识注册",
        "member11": "账户登录",
        "member12": "选择注册方式",
        "member13": "标识注册成功",
        "member14": "标识管理",
        "member15": "第一步",
        "member16": "第二步",
        "member17": "第三步",
        "member18": "第四步",
        "member19": "cstr@cnic.cn",
        "member20": "。",
        "member21": "科学数据中心"
    },
    "keywords": {
        "keywords1": "科学数据",
        "keywords14": "学术论文",
        "keywords17": "专利",
        "keywords20": "专利",
        "keywords26": "学术论文",
        "species": "生物物种",
        "priprent": "预印本"
    },
    "research": {
        "research1": "所属机构",
        "research2": "类别",
        "research3": "内容类型",
        "research4": "学科",
        "research5": "描述",
        "research6": "网址"
    },
    "researchDetail": {
        "research1": "基础信息",
        "research2": "名称：",
        "research3": "所属机构：",
        "research4": "发布日期：",
        "research5": "学科分类：",
        "research6": "关键词：",
        "research7": "所属学科：",
        "research8": "资源地址：",
        "research9": "摘要"
    },
    "news": {
        "news1": "综合新闻",
        "news2": "新闻动态",
        "news3": "新闻详情",
        "news4": "通知公告",
        "news5": "科技交流",
        "news6": "服务成效",
        "news7": "来源：",
        "news8": "中国科学院计算机网络信息中心",
        "news9": "发表时间："
    },
    "organ": {
        "resourceName": "资源名称"
    },
    "newList": {
        "newList1": "中国科学院计算机网络信息中心受邀出席医疗器械物联网管理专业委员会年会",
        "newList2": "2019年11月21-23日，医疗器械物联网管理专业委员会年会暨医疗器械唯一标识创新应用论坛在福建厦门召开。国家和地方监管部门代表，医疗机构、生产流通企业和相关IT企业等行业代表共300余人参加了本次会议。计算机网络信息中心党委书记韩华受邀带队参加本次会议。",
        "newList3": "国内外主流标识标准规范解读",
        "newList4": " 近几年，标识技术不仅支撑了工业互联网、物联网等新型技术领域，在科技资源共享、科学数据开放等新一代科研信息化领域也有着广泛应用，我们从标准规范出发，集中梳理并解读这些国内外主流标识体系，使广大学者和实践者更加系统地理解和学习标识技术。",
        "newList5": "中国科学院计算机网络信息中心参加国际研究数据联盟（RDA）第十四次全体大会",
        "newList6": "2019年10月23日，国际研究数据联盟（RDA）第十四次全体大会在芬兰赫尔辛基召开，来自世界各地的600多名数据科学家和科研工作者参加会议并进行交流，芬兰科学院院长海基·曼尼拉教授做了题为“Bigdata, small data, open data”精彩致辞。为加强科学数据标识领域的国际交流与合作，中国科学院计算机网络信息中心派代表团参加了本次会议。",
        "newList7": "中国科学院计算机网络信息中心中标2019年工业互联网创新发展工程项目",
        "newList8": "近日，在2019年工业互联网创新发展工程激烈的招标竞争中，中国科学院计算机网络信息中心以雄厚的科研创新实力脱颖而出，成功中标2019年工业互联网创新发展工程——标识解析公共服务支撑平台项目（独立中标）和工业互联网标识解析二级节点平台（综合型应用服务平台）分包1项目（联合中标）。"
    },
    "result": {
        "paper": "论文",
        "paper2": "中文标题",
        "paper3": "英文标题",
        "paper4": "发表期刊",
        "paper5": "关键词",
        "paper6": "关键词",
        "paper7": "原文地址",
        "paper8": "来源",
        "paper9": "参考文献",
        "papers10": "标题",
        "paper11": "发表年份",
        "paper12": "作者",
        "papers13": "出版社",
        "papers14": "作者信息",
        "paper15": "项目资助",
        "content": "国家科技基础条件平台专项课题《科技资源标识体系建设共性技术标准研制》",
        "content1": "中国科学院信息化专项《中国科学院科学数据中心体系建设》",
        "content2": "我们的成果",
        "content3": "科研使命",
        "content4": "单位简介",
        "content5": "IANA（The Internet Assigned Numbers Authority），是INTERNET域名系统的最高权威机构，掌握着INTERNET域名系统的设计、维护及地址资源分配等方面的。“Uniform Resource Identifier (URI) Schemes”是IANA维护的重要资源定位符国际标准，该标准支持doi, dns等基础性标识符，目前该标准已采纳cstr标识。",
        "content6": "CSTR成为国际科研人员标识组织ORCID支持的标识符",
        "content7": "ORCID支持的标识标准",
        "content8": "CSTR启动与联合国粮农组织GLIST系统对接",
        "content9": "GLISTtest中的CSTR",
        "content10": "2021年11月20日",
        "content11": "机构网址：",
        "content12": "机构CSTR前缀：",
        "content13": "成员单位",
        "content14": "成果",
        "content15": "请输入正确的前缀",
        "content16": "抱歉，前缀不能为空",
        "content17": "国家标准",
        "content18": "标识服务",
        "content19": "国际合作",
        "content20": "联合国粮食及农业组织（Food and Agriculture Organization of the United Nations，FAO），是联合国系统内最早的常设专门机构，负责粮食和农业问题的国际组织。The Global Information System for PGRFA数据库是FAO的重要基础数据库之一，目前该数据库已采纳cstr标识。",
        "content21": "ORCID（Open Researcher and Contributor ID） 是一个开放学者身份标识组织，已被Nature，Elsevier等出版集团采用，ORCID支持包括doi, pmid等主流科技资源标识，目前ORCID已采纳cstr标识。",
        "content22": "国际存储库采纳",
        "content23": "Harvard Dataverse是哈佛大学开发的开放式在线存储库，用于共享、保存、引用、探索和分析研究数据。 Harvard Dataverse收录超过75,000个数据集和350,000个数据文件，被全世界的研究人员广泛使用，目前该数据库已采纳CSTR标识。",
        "content24": "ePIC是基于Handle系统（TM，https://www.handle.net/ ），由欧盟各个合作伙伴组成的联盟组织，致力于分配和解析永久标识符（PID）。CNIC是ePIC的联盟成员，也是Handle 21节点在中国的唯一代理。",
        "content25": "DataCite是一个全球社区，通过创建和管理持久标识符（PIDs）标注并连接样本、图像、数据、预印本等各种研究成果和资源的元数据，整合服务以改进研究工作流程、促进研究成果和资源的发现和重复利用，使研究更加高效。CNIC是DataCite的会员之一，帮助数据中心和研究人员注册DOI。",
        "content26": "国际电信联盟（International Telecommunication Union，ITU）是主管信息通信技术事务的联合国机构，负责分配和管理全球无线电频谱与卫星轨道资源，制定全球电信标准，向发展中国家提供电信援助，促进全球电信发展。CNIC多次参加ITU-T SG2、SG20线下及线上会议，在物联网标识技术和新型技术结合的应用领域展开投入和探索。",
        "content27": "Crossref是一个2000年成立的非盈利性组织，是国际DOI基金会的注册代理机构之一，旨在实现在线学术期刊中持久的跨出版商引用链接。Crossref的数据包括期刊、书籍、会议论文、技术报告、数据集等，使研究对象易于查找、引用、链接、评估和再利用。",
        "content28": "RAiD（Research Activity Identifier）为研究项目提供持久的、唯一的、可解析的标识符，已认证成为ISO标准，由澳大利亚研究数据共享中心（Australian Research Data Commons，ARDC）管理并提供服务。",
        "content29": "Identifiers.org由欧洲生物信息学研究所 (EMBL-EBI)创建和管理。EMBL-EBI是国际性和创新性机构，其研究领域横跨多个学科，是欧洲分子生物学实验室 (EMBL)的组成部分，也是生命科学领域开放数据的倡导者。Identifiers.org解析服务支持DOI、ORCID、ROR等基础性标识符，目前其解析服务也已支持CSTR标识。",
        "content30": "合作伙伴",
        "content31": "联合国粮食及农业组织",
        "content32": "国际电信联盟",
        "content33": "GOSC全球开放科学云（https://goscloud.net/）旨在通过统一政策、互操作协议、透明服务和持续机制，将不同机构、国家和地区的开放科学云与平台互联起来，为全球合作、开放科学共同设计并构建一个全球电子基础设施及虚拟研究环境。",
        "content34": "STM（International Association of Scientific, Technical and Medical Publishers）是学术出版业的标准制定者，与其成员一起在全球范围内推进全球可信研究。STM支持整个学术研究的创新，并致力于确保我们这个时代的重大发现以精确、清晰和完整的方式被传播。"
    },


    footer: {
        footer1: '京ICP备09112257号-127',
        footer2: '版权所有@2019-2024 中国科学院计算机网络信息中心',
        footer3: '邮箱',
        footer4: '京ICP备09112257号-127',
        footer5: '京公网安备11010802040110号',
        footer7: '中国科学院计算机网络信息中心',
        "footer8": "请求地址",
        "footer9": "环境",
        "footer10": "HTTPS请求地址",
        "footer11": "Method",
        "footer6": "指导单位：",
        "footer273": "标识符类型",
        "footer268": "标识符值",
        "footer263": "替代标识符",
        "footer278": "关联标识符",
        "footer11": "用户须知",
        "footer15": "公共请求参数 Header 传参",
        "footer16": "参数",
        "footer17": "类型",
        "footer18": "是否必填",
        "footer19": "长度",
        "footer21": "示例值",
        "footer26": "分配给开发者的应用ID",
        "footer24": "是",
        "footer30": "是",
        "footer32": "密钥",
        "footer56": "否",
        "footer40": "上传客户端信息",
        "footer36": "描述",
        "footer20": "资源类型",
        "tip": " 请求参数中的{res_name}为标识元数据模板类型的取值范围",
        "footer22": "用于CSTR标识注册，支持科学数据、学术论文、专利、预印本等元数据模板。有任何问题，请邮件联系cstr@cnic.cn。"
    },
    "quote": {
        "quote1": "文献引用量查询",
        "quote2": "描述：",
        "quote3": "引用量：",
        "quote4": "点击查看",
        "quote5": "得分",
        "quote6": "引用",
        "quote7": "文献引用量查询",
        "quote8": "更新时间：",
        "quote9": "文献名称：",
        "quote10": "浏览量",
        "quote11": "解析量",
        "quote12": "平均引用",
        "quote13": "高质量引用",
        "quote14": "请输入CSTR进行查询",
        "quote15": "文献引用量排名",
        "quote16": "专利号"
    },
    warn: {
        warn1: '系统异常，请稍候'
    },
    "newTip": {
        "newTip1": "点击跳转解析",
        "newTip2": "申请人",
        "newTip3": "发明人：",
        "newTip4": "专利名称：",
        "newTip5": "公开年份：",
        "newTip6": "申请号",
        "newTip7": "申请日",
        "newTip8": "公开（公告）号 ",
        "newTip9": "公开（公告）日",
        "newTip10": "申请人",
        "newTip11": "发明人",
        "newTip12": "专利名称、CSTR",
        "newTip13": "机构信息",
        "newTip14": "机构描述：",
        "newTip15": "前缀信息",
        "newTip16": "CSTR前缀不正确",
        "newTip17": "类型：",
        "newTip18": "查看更多",
        "newTip19": "什么是前缀查询？",
        "newTip20": "您可以查询CSTR前缀所属机构的基本信息，包括机构名称、机构官网、基本介绍以及该机构的其他信息。"
    },
    "prefix": {
        "prefix1": "查询结果",
        "prefix2": "CSTR前缀：",
        "prefix3": "类型：",
        "prefix4": "状态：",
        "prefix5": "申请时间：",
        "prefix6": "机构官网：",
        "prefix7": "机构名称：",
        "prefix8": "请输入要查询的CSTR前缀",
        "prefix9": "CSTR前缀不正确"
    },
    "diss": {
        "diss1": "授予机构：",
        "diss2": "培养单位：",
        "diss3": "文章链接：",
        "diss4": "导师：",
        "diss5": "所属机构：",
        "diss6": "参考文献",
        "diss7": "相似文献",
        "diss8": "出版物类型",
        "diss9": "复制成功",
        "diss10": "解析来源：",
        "diss11": "累计解析量：",
        "diss12": "最新被引",
        "diss13": "最新注册",
        "diss14": "最新解析",
        "diss15": "最高被引",
        "diss16": "新增引用",
        "diss17": "更多",
        "diss18": "标题",
        "diss19": "机构",
        "diss20": "关键词",
        "diss21": "标识",
        "diss22": "注册时间",
        "diss23": "解析时间",
        "diss24": "引用时间",
        "diss25": "解析来源",
        "diss26": "累计解析量",
        "diss27": "机构/作者",
        "diss28": "引用量",
        "diss29": "注册标识",
        "diss30": "生物信息",
        "diss31": "被引次数：",
        "newTip18": "查看更多",


    },

    "person": {
        "professional": "职称",
        "organ": "机构",
        "paperTotal": "论文",
        "quoteTotal": "引用",
        "study": "研究方向",
        "static": "作者统计",
        "scanCode": "扫码解析",
        "codeFollow": "扫码分享",
        "allYears": "按年份排序",
        "allTypes": "按引用量排序",
        "sort": "综合排序",
        "regions": '分区',
        "database": "收录",
        "resolve": "解析",
        "iview": "浏览",
        "quote": "引用",
        "search": "检索",
        "paper1": "期刊论文",
        "paper2": "会议论文",
        "paper3": "学位论文",
        "creatorIdentifier": "创建者标识：",
        "homepage": "个人主页",
        "recommen": "国际建议书"

    },
    "apply": {
        "apply1": "邮件发送成功",
        "apply2": "图形验证码不正确",
        "apply3": "系统繁忙，请稍后再试",
        "apply4": "看不清?点击切换",
        "apply5": "获取图形验证码",
        "apply6": "图形验证码不能为空",
        "apply7": "图形验证码"
    },
    "message": {
        "message": "检索内容不能为空",
        "active": "有效",
        "active1": "待激活",
        "active2": "会议通知"
    },
    "meeting": {
        "title": "  The International workshop on Open Science Identifier在北京成功召开"
    },
    "api": {
        "science": "科学数据",
        "journal": "学术论文",
        "patent": "专利",
        "software": "软件著作权",
        "preprints": "预印本",
        "instrument": "仪器设备",
        "diss": "学位论文",
        "parameter": "参数详情",
        "example": "参数示例",
        "register": "注册成功",
        "bad": "请求参数错误",
        "error": "标识注册异常",
        "check": "请检查请求参数格式，是否为合法XML或JSON",
        "verify": "根据返回的参数验证失败信息，修改后重新发起请求"
    },
    "notice": {
        "title": "The International workshop on Open Science Identifier",
        "time": "2023 October 17-18",
        "address": 'Chinese Academy of Sciences Informatization Building and Online',
        "register": 'Register here',
        "intro": 'Event Description',
        "cooperation": "Cooperation Unit",
        "description": 'DataCite and Common Science and Technology Resource Identifier (CSTR) are co-organizing an in-person workshop in Beijing, China, bringing together stakeholders in the Open science and research data management communities to explore the role of persistent identifiers (PIDs) in local and global contexts, demonstrate implementation cases, and discuss recent developments in the global PID ecosystem.',
        'topic': "Event Topic",
        "topicDescripe": 'The workshop will highlight the value of PIDs in the context of PID history and how PID services, tools, and platforms will help to realize the FAIR principle. We will also guide a discussion on the future development trends for PIDs and how to make PIDs more active, stable, and interoperable, with reference to the ongoing PID-related work in the RDA.',
        "topic1": "Topic 1",
        "topic2": "Topic 2",
        "topic3": "Topic 3",
        "topic1Descripe": 'Introduction to CSTR, DataCite, and ORCID persistent identifiers',
        "topic2Descripe": 'Mechanisms, policies and key technologies to support the interconnection of science and technology resource identification for open scientific data',
        "topic3Descripe": 'Typical Use Cases of Science Data Centers',
        "schedule": 'Workshop Agenda',
        "day1": 'DAY1',
        "date1": 'October 17, Tuesday',
        'tuesday': 'Tuesday',
        'tbd': '',
        'content1': 'Welcome and introduction speech',
        "content2": 'Global Open Identifier: Alignment and interoperability across PIDs',
        "name1": "Jia Liu",
        "name2": "Xin Li",
        "name3": "Jianhua Liu",
        "name4": "Estelle Cheng",
        "name5": "Chen Xin",
        "name6": "Xiaoli Chen",
        "name7": "Lulu Jiang",
        "name8": "Yan Xi",
        "content3": 'Connecting Research, Advancing Knowledge: global infrastructure efforts',
        "content4": 'Invited talk from National Tibetan Plateau Data Center',
        "content5": 'Introduction to Wanfang consortium',
        'MoreImpact': 'More Impact, Less Effort: Laying the Foundation for research data management through PIDs like ORCiD',
        "Implementing": 'Signing of  CSTR & DataCite MOU',
        "InvitedTalk": 'Invited talk from Scientific Data Center of CAS',
        "Review": 'Coffee Break',
        "report": 'Invited talk from National Space Science Data Center',
        "report1": 'Invited talk from National Cryosphere Desert Data Center',
        "report2": 'Invited talk from National Astronomical Data Center',
        "report3": 'Moderated discussion',
        "day2": "DAY2",
        "date2": " October 18, Wednesday",
        "process": "Implementing FAIR Workflows",
        "dayReport": "Invited talk from Science Data Bank ",
        "dayReport2": "Invited talk from  China National Genebank",
        "dayReport3": "Invited talk from National Geological Archives of China",
        "dayReport4": "Science Data and Science Data Paper Publishing",
        "dayReport5": "Review and wrap up",
        "afternoon": "Afternoon",
        "DataCite": "DataCite APAC EG",
        "cstr": "CSTR Community aims to promote the establishment of a global science and technology resource identification architecture that can trace global influence, cross disciplines, cross regions, and cross platforms. This will enable rapid positioning and acquisition of resources worldwide and serve as the digital foundation for open science. The CSTR identifier has been accepted as one of the IANA international standards, and it has contributed to scientific research innovation. CSTR provides unique identification services for global scientific data, papers, scientific institutions, researchers, scientific instruments, patents, and other scientific and technological resources. DataCite is a global community that shares the vision of opening and connecting research outputs and resources to promote inter- and cross-disciplinary reuse. DataCite has been working with organizations in China and the wider APAC region to encourage the adoption of open PIDs and metadata workflows in the research data management process.",
        "datacite": "DataCite and Common Science and Technology Resource Identifier (CSTR) are co-organizing an in-person workshop in Beijing, China, bringing together stakeholders in the Open science and research data management communities to explore the role of persistent identifiers (PIDs) in local and global contexts, demonstrate implementation cases, and discuss recent developments in the global PID ecosystem.",
        "participate": "How to participate",
        "methods1": "Offline Participation send email to",
        "methods2": "Online Participation",
        "methods3": "Register here",
        "theme": "Join the forthcoming International Workshop on Open Science Identifier starting on Tuesday 17 October 2023"

    }
}